module.exports = __webpack_public_path__ + "static/media/dish7.3f56deb7.jpg";